<template lang="html">
  <div class="pa-3">
    <v-layout row wrap pa-4 class="elevation-1 box-card">
      <v-flex xs12 class="box-title">
        <strong>Destaques</strong>
      </v-flex>
      <v-flex xs12>
        <v-tabs grow slider-color="red">
          <v-tab
            v-for="tab in tabsDestaquesNotificacao"
            :key="tab.url"
            :href="'#' + tab.url"
            :ripple="false"
            @click="tab.notificacao !== undefined ? apagaNotificacao(tab.url) : null"
          >
            <v-badge right ml-2 color="notificacao-red"  v-if='tab.notificacao !== undefined'>
              <span slot="badge">{{ tab.notificacao }}</span>
                {{ tab.nome }}
            </v-badge>
            <template v-else>
              {{ tab.nome }}
            </template>
          </v-tab>
          <v-tab-item
            v-for="tab in tabsDestaquesNotificacao"
            :key="tab.url"
            :id="tab.url"
            class="no-bar"
            style="height:405px;overflow-y:scroll;">
              <v-card flat v-if="tab.url==='Pedidos/Novos'">
                <v-card-text v-if="orders.length > 0">
                  <order v-for="order in orders" :value="order" :key="order.id" @details="details($event)"></order>
                </v-card-text>
                <v-card-text v-else class="nothing-new">
                  Nenhum pedido foi localizado
                </v-card-text>
              </v-card>
              <v-card flat v-else>
                <v-card-text  v-if="estimations.length > 0">
                  <order v-for="estimation in estimations" :value="estimation" :key="estimation.id" @details="details($event)"></order>
                </v-card-text>
                <v-card-text v-else class="nothing-new">
                  Nenhum orçamento foi localizado
                </v-card-text>
              </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-progress-linear class="loading-box" v-if="loadingFeatured" height="2" color="red" v-bind:indeterminate="true"></v-progress-linear>
    </v-layout>
  </div>
</template>

<script>
import order from '@/components/painel/sharedComponents/order/'
export default {
  name: 'featured',
  components: {
    'order': order
  },
  data () {
    return {
      destaque: null,
      pesquisar: '',
      tabDestaques: [
        {
          nome: 'Pedidos',
          url: 'Pedidos/Novos'
        },
        {
          nome: 'Orçamentos',
          url: 'Orcamentos/Novos'
        }
      ]
    }
  },
  computed: {
    loadingFeatured () {
      return this.$store.getters.loadingFeatured
    },
    orders () {
      return this.$store.getters.newOrders
    },
    estimations () {
      return []
    },
    tabsDestaquesNotificacao () {
      let mapa = JSON.parse(JSON.stringify(this.tabDestaques))
      return mapa.map(elem => {
        let notificacao = this.$store.getters.notificacao.filter(elemento => elemento.url === elem.url)
        if (notificacao.length > 0) {
          elem.notificacao = notificacao[0].quantidade
          return elem
        } else {
          return elem
        }
      })
    }
  },
  methods: {
    pedidos () {
      this.$router.push('/Painel/Pedidos/Novos/')
    },
    itens () {
      this.$router.push('/Painel/Itens/Relacao/')
    },
    avaliacoes () {
      this.$router.push('/Painel/Atendimento/')
    },
    negocios () {
      this.$router.push('/Painel/Negocios/')
    },
    agendamento () {
      this.$router.push('/Painel/Agendamento/')
    }
  },
  mounted () {
    this.$store.dispatch('getFeaturedNewOrders')
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// featured.vue?69cc98d4